import Vue from 'vue';
import EmiratesPromoBanner from '../ui/EmiratesPromoBanner.vue';

export type EmiratesPromoBannerVariant = 'main' | 'serp';

const CONTAINER_SELECTOR = '.js-emirates-promo-banner';

const mountedContainers = new WeakSet<HTMLElement>();

const createBannerInstance = (variant: EmiratesPromoBannerVariant): Vue =>
    new Vue({
        render: (h) => h(EmiratesPromoBanner, { props: { variant } }),
    });

export const createEmiratesPromoBannerElement = (variant: EmiratesPromoBannerVariant): HTMLElement => {
    const instance = createBannerInstance(variant).$mount();
    return instance.$el as HTMLElement;
};

const mountAllBanners = (): void => {
    document.querySelectorAll<HTMLElement>(CONTAINER_SELECTOR).forEach((container) => {
        if (mountedContainers.has(container)) return;
        mountedContainers.add(container);
        const variant: EmiratesPromoBannerVariant = container.dataset.variant === 'serp' ? 'serp' : 'main';
        createBannerInstance(variant).$mount(container);
    });
};

export default function initEmiratesPromoBanner(): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => mountAllBanners(), { once: true });
    } else {
        mountAllBanners();
    }
}
